import { InjectionToken } from '@angular/core';

export const SN_GOOGLE_API_KEY = new InjectionToken<string>('SN_GOOGLE_API_KEY');
